module.exports = __webpack_public_path__ + "img/dog-default-picture-color.2f9d5995.png";